import { fitProductColorSwatches } from "../woocommerce/product-color-swatches";

export const homeHeroSlider = () => {
  const sectionHomeHero = document.getElementById("homeHeroSlider");
  if (!sectionHomeHero) return;

  let isHeroInView = true;
  let imageTimeout = null;
  let currentVideo = null;

  const splide = new Splide(".splide-home-hero", {
    type: "fade",
    drag: true,
    rewind: true,
    perPage: 1,
    arrows: true,
    pagination: false,
    autoplay: false,
    video: {
      loop: true,
      mute: true,
      autoplay: false,
      playsinline: 1,
    },
  });

  const applyFixedHeaderTheme = () => {
    // Once the hero scrolls out of view, the header always gets the same
    // treatment everywhere else on the page: dark icons/logo on a white
    // header background (see .header.isWhite in header.scss) — sections no
    // longer flip the navbar theme individually.
    const elements = [
      document.querySelector(".navbar__logo"),
      document.querySelector(".navbar"),
      document.querySelector("#toggleMenu"),
      document.querySelector("#toggleMenu .burger"),
      document.querySelector("#homeNav"),
    ];
    elements.forEach((el) => {
      if (!el) return;
      el.classList.remove("isLight");
      el.classList.add("isDark");
    });
    document.querySelector("#header")?.classList.add("isWhite");
  };

  const updateNavbarTheme = () => {
    // Only the hero slider owns the navbar theme while it is on screen. Once
    // the hero is scrolled out of view, applyFixedHeaderTheme() takes over
    // (see the IntersectionObserver below) and this must not override it.
    if (!isHeroInView) return;

    const currentSlide = splide.Components.Slides.getAt(splide.index)?.slide;
    if (!currentSlide) return;
    const headerType = currentSlide.getAttribute("data-slider-header-type");

    const elements = [
      document.querySelector(".navbar__logo"),
      document.querySelector(".navbar"),
      document.querySelector("#toggleMenu"),
      document.querySelector("#toggleMenu .burger"),
      document.querySelector("#homeHeroSlider .splide__arrows"),
      document.querySelector("#homeNav"),
    ];

    document.querySelector("#header")?.classList.remove("isWhite");
    elements.forEach((el) => {
      if (!el) return;
      el.classList.remove("isLight", "isDark");
      if (headerType === "light") el.classList.add("isLight");
      else if (headerType === "dark") el.classList.add("isDark");
    });
  };

  const playActiveSlideMedia = () => {
    clearTimeout(imageTimeout);
    imageTimeout = null;

    if (currentVideo) {
      currentVideo.pause();
      currentVideo.currentTime = 0;
      currentVideo.onended = null;
      currentVideo = null;
    }

    const activeSlide = splide.Components.Slides.getAt(splide.index)?.slide;
    if (!activeSlide) return;

    updateNavbarTheme();

    const video = activeSlide.querySelector("video");

    if (video && isHeroInView) {
      currentVideo = video;
      video.currentTime = 0;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === "function") {
        playPromise.catch(() => {});
      }
      video.onended = () => splide.go("+1");
    } else if (isHeroInView) {
      imageTimeout = setTimeout(() => {
        splide.go("+1");
      }, 7000);
    }
  };
  const heroVideoMQ = window.matchMedia("(max-width: 767px)");
  const applyHeroVideoSources = () => {
    sectionHomeHero
      .querySelectorAll("video[data-src-desktop]")
      .forEach((video) => {
        const next = heroVideoMQ.matches
          ? video.dataset.srcMobile
          : video.dataset.srcDesktop;
        if (!next || video.getAttribute("src") === next) return;

        const wasPlaying = !video.paused;
        video.setAttribute("src", next);
        video.load();
        if (wasPlaying) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === "function") {
            playPromise.catch(() => {});
          }
        }
      });
  };

  applyHeroVideoSources();
  heroVideoMQ.addEventListener("change", applyHeroVideoSources);

  splide.mount(window.splide.Extensions);

  playActiveSlideMedia();

  splide.on("moved", () => {
    playActiveSlideMedia();
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const wasInView = isHeroInView;
        isHeroInView = entry.isIntersecting;

        if (isHeroInView && !wasInView) {
          playActiveSlideMedia();
          updateNavbarTheme();
        } else if (!isHeroInView) {
          if (currentVideo) currentVideo.pause();
          if (wasInView) applyFixedHeaderTheme();
        }
      });
    },
    // Nie 1: przy auto height hero bywa wyższe niż viewport (wysoka grafika
    // na wąskim ekranie), więc pełna widoczność nie nastąpiłaby nigdy —
    // a wtedy isHeroInView=false blokuje odtwarzanie wideo.
    { threshold: 0.5 }
  );

  observer.observe(sectionHomeHero);
};

export const HomeInspirationsSlider = () => {
  const sectionHomeInspirations = document.getElementById("inspirationPart");
  if (sectionHomeInspirations) {
    const splide = new Splide(".splide-home-inspirations", {
      type: "slide",
      perPage: 5,
      perMove: 1,
      drag: true,
      rewind: false,
      arrows: true,
      gap: "16px",
      pagination: false,
      breakpoints: {
        1200: {
          perPage: 4,
          perMove: 1,
        },
        991: {
          perPage: 3,
          perMove: 1,
        },
        576: {
          perPage: 1,
          perMove: 1,
        },
      },
    });
    splide.mount();
  }
};

export const HomeBlogSlider = () => {
  const sectionBlogInspirations = document.getElementById("blogPart");
  if (sectionBlogInspirations) {
    const splide = new Splide(".splide-home-blog", {
      type: "slide",
      perPage: 4,
      perMove: 1,
      drag: true,
      rewind: false,
      arrows: true,
      gap: "16px",
      pagination: false,
      breakpoints: {
        1200: {
          perPage: 3,
          perMove: 1,
        },
        991: {
          perPage: 2,
          perMove: 1,
        },
        576: {
          perPage: 1,
          perMove: 1,
        },
      },
    });
    splide.mount();
  }
};

export const SimpleCategories = (element = null) => {
  const splideElement =
    element || document.querySelector(".splide--simple-categories");

  if (!splideElement) return;
  const splide = new Splide(splideElement, {
    type: "slide",
    perPage: 4,
    perMove: 1,
    rewind: false,
    gap: "24px",
    arrows: true,
    pagination: false,
    breakpoints: {
      1200: {
        fixedWidth: "30%",
        gap: "24px",
        perPage: 3,
      },
      767: {
        fixedWidth: "45%",
        gap: "16px",
        perPage: 2,
      },
      475: {
        fixedWidth: "45%",
        perPage: 2,
      },
    },
  });
  const barWrapper = splide.root.querySelector(
    ".simple-categories__slider-progress"
  );
  const bar = splide.root.querySelector(".simple-categories__slider-bar");

  splide.on("mounted", function () {
    const totalSlides = splide.Components.Slides.getLength();
    const visibleSlides = splide.options.perPage;

    if (totalSlides <= visibleSlides) {
      if (barWrapper) {
        barWrapper.style.display = "none";
      }
    } else {
      splide.on("move", function () {
        const maxScrollIndex = totalSlides - visibleSlides;
        const progress = Math.min(splide.index / maxScrollIndex, 1);

        if (bar) {
          const parentWidth = barWrapper.offsetWidth;
          const calculatedWidth = progress * parentWidth;
          const minWidth = 115;

          bar.style.width = `${Math.max(calculatedWidth, minWidth)}px`;
        }
      });
    }
  });
  splide.mount();
};

export const ProductMiniatureGallerySlider = (element = null) => {
  ProductMiniatureGallerySliderLazy(element);
};

export const ProductMiniatureGallerySliderLazy = (element = null) => {
  if (
    ["Event", "TouchEvent", "MouseEvent"].includes(element?.constructor?.name)
  ) {
    element = null;
  }

  if (element === null) {
    if (window.productMiniatureGallerySlidersLoaded) return;
    window.productMiniatureGallerySlidersLoaded = true;
  }

  const sliders = element
    ? [element]
    : document.querySelectorAll(".splide--product-thumbnail-slider");

  sliders.forEach((sliderElement) => {
    new Splide(sliderElement, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      rewind: true,
      drag: false,
      arrows: true,
      pagination: false,
      lazyLoad: "nearby",
    }).mount();
  });
};

export const completeProductsSlider = () => {
  const completeYourProduct = document.getElementById("completeYourProduct");
  if (completeYourProduct) {
    const splide = new Splide(".splide--complete-products", {
      type: "slide",
      perPage: 5,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "16px",
      breakpoints: {
        1920: {
          perPage: 4,
        },
        991: {
          perPage: 3,
        },
        767: {
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }
};

export const relatedProductsSlider = () => {
  const relatedProducts = document.getElementById("relatedProducts");
  if (relatedProducts) {
    const splide = new Splide(".splide--related-products", {
      type: "slide",
      perPage: 4,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        1100: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }
};

export const upSellProductsSlider = () => {
  const upSellProducts = document.getElementById("upsellSlider");
  if (upSellProducts) {
    const splide = new Splide(".splide--product-upsell", {
      type: "slide",
      perPage: 4,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        1100: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    const prevArrow = document.querySelector(".forget-slider-arrow--prev");
    const nextArrow = document.querySelector(".forget-slider-arrow--next");

    if (prevArrow && nextArrow) {
      prevArrow.addEventListener("click", () => splide.go("<"));
      nextArrow.addEventListener("click", () => splide.go(">"));
    }
    splide.mount();
  }
};

const buildGallerySlides = (mainEl) => {
  mainEl.querySelectorAll(":scope > a").forEach((el) => el.remove());

  const track = document.createElement("div");
  track.className = "splide__track";
  const list = document.createElement("ul");
  list.className = "splide__list";
  track.appendChild(list);

  const thumbLinks = document.querySelectorAll(
    ".woocommerce-product-gallery__thumbs a"
  );

  thumbLinks.forEach((link) => {
    const slide = document.createElement("li");
    slide.className = "splide__slide";

    const clone = link.cloneNode(true);
    clone.setAttribute("data-fslightbox", "product-gallery");

    const fullSrc = clone.dataset.fullSrc;
    const img = clone.querySelector("img");
    if (fullSrc && img) {
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      img.setAttribute("data-splide-lazy", fullSrc);
    }

    clone.querySelectorAll("video").forEach((v) => {
      v.removeAttribute("id");
      v.autoplay = true;
      v.loop = true;
      v.playsInline = true;
    });

    slide.appendChild(clone);
    list.appendChild(slide);
  });

  mainEl.appendChild(track);
  return list;
};

export const productGallerySlider = () => {
  const mainEl = document.querySelector(".woocommerce-product-gallery__main");
  if (!mainEl) return;

  if (mainEl.splide) {
    mainEl.splide.destroy();
    mainEl.classList.remove("splide", "is-initialized", "is-active");
    mainEl.querySelector(".splide__track")?.remove();
  }

  const thumbLinks = [
    ...document.querySelectorAll(".woocommerce-product-gallery__thumbs a"),
  ];
  if (!thumbLinks.length) return;

  buildGallerySlides(mainEl);
  mainEl.classList.add("splide");

  const startIndex = Math.max(
    0,
    thumbLinks.findIndex((link) => link.classList.contains("is-active"))
  );

  const splide = new Splide(mainEl, {
    type: "slide",
    direction: "ttb",
    height: "100%",
    perPage: 1,
    perMove: 1,
    drag: true,
    wheel: true,
    wheelSleep: 500,
    releaseWheel: true,
    arrows: false,
    pagination: true,
    rewind: false,
    lazyLoad: "nearby",
    speed: 800,
    start: startIndex,
  });

  splide.on("moved", (newIndex) => {
    thumbLinks.forEach((link, i) =>
      link.classList.toggle("is-active", i === newIndex)
    );
    thumbLinks[newIndex]?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  });

  thumbLinks.forEach((link, index) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      splide.go(index);
    });
  });

  splide.mount();

  if (typeof refreshFsLightbox === "function") {
    refreshFsLightbox();
  }

  const lightbox = window.fsLightboxInstances?.["product-gallery"];
  if (lightbox) {
    lightbox.props.maxScale = true;
  }

  const thumbsEl = document.querySelector(
    ".woocommerce-product-gallery__thumbs"
  );

  // .woocommerce-product-gallery's height is viewport-relative (vh-based), so
  // it changes on window resize/orientation change even though it no longer
  // animates on scroll — Splide's height: "100%" only measures once at mount,
  // so without this its track would keep a stale pixel height after such a
  // resize. rAF-throttled ResizeObserver callbacks keep it in sync.
  //
  // Also caps the thumb rail's height to match __main's actual rendered
  // height: __main uses align-self: flex-start so its height comes from its
  // own aspect-ratio (not the row's full height), but __thumbs still stretches
  // to the row's full height by default — at 16:10 (shorter than the old 1:1
  // square) that leaves visible empty space below the rail. Since __thumbs'
  // width is fixed (unrelated to the photo's aspect-ratio), there's no pure-
  // CSS way to derive its height from __main's, so this measures it directly.
  // Also needed whenever __main's aspect-ratio changes (e.g. the --square
  // modifier), not just on resize.
  let resizeFrame = null;
  const resizeObserver = new ResizeObserver(() => {
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(() => {
      splide.refresh();
      if (thumbsEl) {
        thumbsEl.style.maxHeight = `${mainEl.getBoundingClientRect().height}px`;
      }
      resizeFrame = null;
    });
  });
  const galleryEl = mainEl.closest(".woocommerce-product-gallery");
  if (galleryEl) resizeObserver.observe(galleryEl);
  if (thumbsEl) {
    thumbsEl.style.maxHeight = `${mainEl.getBoundingClientRect().height}px`;
  }
};

export const HomeBestsellersSlider = () => {
  const sectionBestsellers = document.getElementById("bestsellers");
  if (sectionBestsellers) {
    const splide = new Splide(".splide-home-bestsellers", {
      type: "slide",
      perPage: 4,
      perMove: 1,
      drag: true,
      noDrag: ".yith-wcqv-button",
      rewind: true,
      arrows: true,
      pagination: false,
      gap: "16px",
      breakpoints: {
        1200: {
          perPage: 3,
        },
        991: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });

    splide.mount();
    fitProductColorSwatches();

    // The TrustMate multihornet star-rating widget loads asynchronously from
    // an external script and can grow .product-bestseller__rating after the
    // swatch widths above were measured, pushing the color list past the
    // card edge. Re-measure whenever that sibling's size actually changes.
    if ("ResizeObserver" in window) {
      const ratingBlocks = sectionBestsellers.querySelectorAll(".product-bestseller__rating");
      if (ratingBlocks.length) {
        const resizeObserver = new ResizeObserver(() => fitProductColorSwatches());
        ratingBlocks.forEach((el) => resizeObserver.observe(el));
      }
    }
  }
};

export const AboutFeaturesSlider = () => {
  const sectionAboutFeatures = document.getElementById("aboutFeatures");
  if (sectionAboutFeatures) {
    const splide = new Splide(".splide-about-features", {
      type: "slide",
      grid: {
        rows: 2,
        cols: 3,
        gap: {
          row: "64px",
          col: "32px",
        },
      },
      drag: false,
      rewind: false,
      arrows: false,
      pagination: true,
      breakpoints: {
        991: {
          grid: {
            rows: 3,
            cols: 2,
          },
        },
        767: {
          grid: false,
          drag: true,
        },
      },
    });
    splide.mount(window.splide.Extensions);
  }
};

export const plantTreeHowItWorksSlider = () => {
  const sectionPlantTreeHowItWorks = document.getElementById(
    "plantTreeHowItWorks"
  );
  if (sectionPlantTreeHowItWorks) {
    const splide = new Splide(".splide-plant-tree-how-it-works", {
      type: "slide",
      grid: {
        rows: 2,
        cols: 1,
        gap: {
          row: "32px",
          col: "32px",
        },
      },
      drag: false,
      rewind: false,
      arrows: false,
      pagination: true,
      breakpoints: {
        991: {
          grid: {
            rows: 1,
            cols: 1,
            drag: true,
            rewind: true,
          },
        },
        767: {
          grid: {
            rows: 1,
            cols: 1,
          },
          drag: true,
          rewind: true,
        },
      },
    });
    splide.mount(window.splide.Extensions);
  }
};

export const AboutGallerySlider = () => {
  const sectionAboutGallery = document.getElementById("aboutGallery");
  if (sectionAboutGallery) {
    const splide = new Splide(".splide-about-gallery", {
      type: "slide",
      perPage: 1,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: true,
      pagination: false,
    });
    var bar = splide.root.querySelector(".splide-slider-progress-bar");
    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      var maxWidth = 115;
      bar.style.width = String(maxWidth * rate) + "px";
    });
    splide.mount();
  }
};

export const MaterialCloseUpSliders = () => {
  const section = document.getElementById("materialCloseUps");
  if (!section) return;
  const sliders = section.querySelectorAll(".splide-close-up");
  sliders.forEach((sliderElement) => {
    const splide = new Splide(sliderElement, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
    });
    splide.mount();
  });
};

export const DontForgetToAddToCartSlider = () => {
  const sectionDontForgetToAddToCart = document.getElementById(
    "dont-forget-to-add-to-cart"
  );
  if (sectionDontForgetToAddToCart) {
    const splide = new Splide(".splide-home-dont-forget-to-add-to-cart", {
      type: "slide",
      perPage: 4,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        1100: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    const prevArrow = document.querySelector(".forget-slider-arrow--prev");
    const nextArrow = document.querySelector(".forget-slider-arrow--next");

    if (prevArrow && nextArrow) {
      prevArrow.addEventListener("click", () => splide.go("<"));
      nextArrow.addEventListener("click", () => splide.go(">"));
    }
    splide.mount();
    fitProductColorSwatches();
  }
};

export const blogBestsellersSlider = () => {
  const section = document.getElementById("blogBestsellers");
  if (!section) return;

  const splide = new Splide(".splide--blog-bestsellers", {
    type: "slide",
    perPage: 4,
    perMove: 1,
    drag: true,
    rewind: true,
    arrows: false,
    pagination: true,
    gap: "24px",
    breakpoints: {
      1440: { gap: "24px", perPage: 4 },
      1100: { gap: "16px", perPage: 3 },
      767: { perPage: 2 },
      576: { perPage: 1 },
    },
  });
  splide.mount();
};

export const refreshSlider = (sliderSelector, initFunction) => {
  const sliders = document.querySelectorAll(`.${sliderSelector}`);

  if (sliders.length === 0) {
    return;
  }

  sliders.forEach((sliderElement) => {
    if (sliderElement.splide) {
      sliderElement.splide.destroy();
    }

    initFunction(sliderElement);
  });
};

export const destroyExistingSlider = (sliderSelector) => {
  const sliderElements = document.querySelectorAll(`.${sliderSelector}`);

  sliderElements.forEach((sliderElement) => {
    if (sliderElement.splide) {
      sliderElement.splide.destroy();
    }
  });

  return sliderElements.length > 0 ? sliderElements : null;
};

const HomeReviewSlider = () => {
  const sectionHomeReview = document.getElementById("homeReview");
  if (!sectionHomeReview) return;

  const splide = new Splide(".splide-home-review", {
    type: "fade",
    drag: true,
    rewind: true,
    perPage: 1,
    arrows: false,
    pagination: true,
    autoplay: true,
    interval: 6000,
    pauseOnHover: true,
  });

  splide.on("mounted", () => {
    const target = document.getElementById("homeReviewPagination");
    const pagination = sectionHomeReview.querySelector(".splide__pagination");
    if (target && pagination) target.appendChild(pagination);
  });

  splide.mount();
};

export const loadHomeSliders = () => {
  if (window.homeSlidersLoaded) return;
  window.homeSlidersLoaded = true;

  HomeBestsellersSlider();
  HomeInspirationsSlider();
  HomeBlogSlider();
  HomeReviewSlider();
};

export const productCardCertificatesSlider = () => {
  const sectionCertificates = document.getElementById(
    "productCardCertificatesSection"
  );
  if (!sectionCertificates) return;

  const splide = new Splide(".splide-product-company-cert", {
    type: "slide",
    direction: "ttb",
    perPage: 1,
    perMove: 1,
    drag: true,
    arrows: true,
    pagination: true,
    wheel: true,
    height: "auto",
    breakpoints: {
      475: {
        direction: "ltr",
        wheel: false,
      },
    },
  });

  const setTrackHeight = () => {
    const activeSlide = splide.Components.Elements.slides[splide.index];
    if (activeSlide) {
      const height = activeSlide.offsetHeight;
      const track = splide.root.querySelector(".splide__track");
      if (track) {
        track.style.setProperty("height", `${height}px`);
      }
    }
  };

  splide.on("mounted move", setTrackHeight);
  splide.mount();
};

export const landingProductsSlider = () => {
  const sliders = document.querySelectorAll(".splide--landing-products");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const splide = new Splide(slider, {
      type: "slide",
      perPage: 3,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        991: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    const prevArrow = slider.querySelector(
      ".splide__arrows--landing .splide__arrow--prev"
    );
    const nextArrow = slider.querySelector(
      ".splide__arrows--landing .splide__arrow--next"
    );

    if (prevArrow && nextArrow) {
      prevArrow.addEventListener("click", () => splide.go("<"));
      nextArrow.addEventListener("click", () => splide.go(">"));
    }
    splide.on("mounted resized", () => fitProductColorSwatches());
    splide.mount();
  });
};
export const landingProductsSliderLg = () => {
  const sliders = document.querySelectorAll(".splide--landing-products--lg");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const splide = new Splide(slider, {
      type: "slide",
      perPage: 4,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 4,
        },
        1200: {
          gap: "24px",
          perPage: 3,
          grid: false,
        },
        991: {
          gap: "16px",
          perPage: 2,
          grid: false,
        },
        576: {
          perPage: 1,
        },
      },
    });
    const prevArrow = slider.querySelector(
      ".splide__arrows--landing .splide__arrow--prev"
    );
    const nextArrow = slider.querySelector(
      ".splide__arrows--landing .splide__arrow--next"
    );

    if (prevArrow && nextArrow) {
      prevArrow.addEventListener("click", () => splide.go("<"));
      nextArrow.addEventListener("click", () => splide.go(">"));
    }
    splide.on("mounted resized", () => fitProductColorSwatches());
    splide.mount();
  });
};

export const landingProductsSliderGrid = () => {
  const sliders = document.querySelectorAll(".splide--landing-grid");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const splide = new Splide(slider, {
      type: "slide",
      gap: "24px",
      pagination: true,
      arrows: false,
      drag: true,
      rewind: true,
      perMove: 1,
      grid: {
        rows: 2,
        cols: 4,
        gap: { row: "24px", col: "24px" },
      },
      breakpoints: {
        1440: {
          gap: "24px",
          grid: {
            rows: 2,
            cols: 4,
            gap: { row: "24px", col: "24px" },
          },
        },
        1200: {
          gap: "24px",
          perPage: 3,
          grid: false,
        },
        991: {
          gap: "16px",
          perPage: 2,
          grid: false,
        },
        576: {
          perPage: 1,
          grid: false,
        },
      },
    });

    const prevArrow = slider.querySelector(
      ".splide__arrows--landing .splide__arrow--prev"
    );
    const nextArrow = slider.querySelector(
      ".splide__arrows--landing .splide__arrow--next"
    );

    if (prevArrow && nextArrow) {
      prevArrow.addEventListener("click", () => splide.go("<"));
      nextArrow.addEventListener("click", () => splide.go(">"));
    }

    splide.on("mounted resized", () => fitProductColorSwatches());
    splide.mount(window.splide.Extensions);
  });
};
